let defaultClassManager = {
	data () {
		return {
			COLUMN_CLASS_PREFIX: 'col-sm-2',
			DEFAULT_VALUE_CLASS: 'def-val',
			DEFAULT_LOCK_CLASS: 'def-lock',
		}
	},
	methods: {
		getDefaultValueWithLockClasses: function () {
			if (this.lockedEdit) {
				return ''
			}
			return (this.defaultValue == null) ? '' : this.DEFAULT_VALUE_CLASS + ' ' + this.getDefaultLockClass()
		},
		getDefaultLockClass: function () {
			return this.defaultLock ? this.DEFAULT_LOCK_CLASS : ''
		},
		getColumnClass: function () {
			return ''
		}
	}
}

export default defaultClassManager
